import * as yup from 'yup';

export const schema = yup.object().shape({
  plate: yup.string().required('Obrigatório'),
  chassi: yup.string().required('Obrigatório'),
  renavam: yup.string().required('Obrigatório'),
  cpfCnpj: yup.string().required('Obrigatório'),
  rntc: yup.string().required('Obrigatório'),
});
